import {
    Component,
    ViewChild,
    Injector,
    Output,
    EventEmitter,
    OnInit,
    ElementRef,
    ViewChildren,
    QueryList,
} from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
    CommonLookupServiceProxy,
    AccountJournalServiceProxy,
    CreateOrEditSalesDto,
    FindCustomerOutputDto,
    DropDownLookupDto,
    FindProductOutputDto,
    CreateOrEditSalesDetailDto,
    TaxDto,
    CurrencyDto,
    GetPurchaseForEditInput,
    Status,
    ApplicableUnitForProduct,
    GetSalesForEditInput,
    ChartOfAccountDto,
    JournalHeaderDto,
    JournalDetailDto,
    GetJournalVoucherForInput,
    JournalType,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    templateUrl: './create-or-edit-journalvoucher.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditJournalVoucherComponent extends AppComponentBase implements OnInit {
    @ViewChildren('itemCodeInput') itemCodeInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('descriptionInputs') descriptionInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('debitInputs') debitInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('creditInputs') creditInputs!: QueryList<ElementRef<HTMLInputElement>>;
    
    @ViewChildren('addButton') addButtons!: QueryList<ElementRef<HTMLButtonElement>>;
    active = false;
    saving = false;
    customerSelectedItem: FindCustomerOutputDto;
    productSelectedItem: FindProductOutputDto;
    customers: FindCustomerOutputDto[];
    products: FindProductOutputDto[];
    applicableTaxes: TaxDto[];
    units: any[] = [];
    status = Status;

    filterText = '';

    journalHeader: JournalHeaderDto = new JournalHeaderDto();
    journalDetails: JournalDetailDto[];
    journalDetail: JournalDetailDto = new JournalDetailDto();
    
    totalQty = 0;
    localTotal = 0;
    allChartOfAccounts: ChartOfAccountDto[];

    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('journalHeader'), '/app/purchase/journalHeaders'),
        new BreadcrumbItem(this.l('Entity_Name_Plural_Here') + '' + this.l('Details')),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _journalHeadersServiceProxy: AccountJournalServiceProxy,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.show(this._activatedRoute.snapshot.queryParams['id']);
        this.addRow(0);
    }

    removeItem(index: number) {
        this.journalDetails.splice(index, 1);

        if (this.journalDetails.length == 0) {
            this.addRow(index);
        }

        var i = 1;
        this.journalDetails.forEach((c) => {
            c.slNo = i++;
        });

        this.productSelectedItem = null;
    }

    focusNext(type: 'description' | 'debit' | 'credit'| 'add' | 'nextRow', index: number) {
        if (type === 'description') {
            const next = this.descriptionInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'debit') {
            const next = this.debitInputs.get(index);
            next?.nativeElement.focus();
            setTimeout(() => next.nativeElement.select(), 0);
        } else if (type === 'credit') {
            const next = this.creditInputs.get(index);
            next?.nativeElement.focus();
            setTimeout(() => next.nativeElement.select(), 0);
        } else if (type === 'add') {
            const next = this.addButtons.get(index);
            next?.nativeElement.focus();
        } else if (type === 'nextRow') {
            if (index === this.journalDetails.length - 1) {
                this.addRow(index);
                setTimeout(() => {
                    const nextItem = this.itemCodeInputs.get(index + 1);
                    nextItem?.nativeElement.focus();
                });
            } else {
                const nextItem = this.itemCodeInputs.get(index + 1);
                nextItem?.nativeElement.focus();
            }
        }
    }

    addRow(index: number): void {
        if (this.journalDetails == null) this.journalDetails = [];

        this.journalDetail = new JournalDetailDto();
        this.journalDetail.slNo = this.journalDetails.length + 1;
        this.journalDetail.debit = 0;
        this.journalDetail.credit = 0;
        this.journalDetail.accountId = 0;
        this.journalDetail.accountCode = null;
        this.journalDetails.push(this.journalDetail);

        const nextItem = this.itemCodeInputs.get(index + 1);
        nextItem?.nativeElement.focus();
    }


    getAccountCode(value: any, data: JournalDetailDto,index:number): void {
        var account = this.allChartOfAccounts.find(c => c.id == value.target.value);
        data.accountCode = account.code;
        data.accountId = value.target.value;
        this.focusNext('description', index);
    }

    searchAccount(accountCode: string, data: JournalDetailDto, index: number) {
        var account = this.allChartOfAccounts.find((c) => c.code == accountCode);
        if (account != null) {
            data.accountId = account.id;
            this.focusNext('description', index);
        } else {
            abp.notify.error('AccountNotFound');
            data.accountCode = '';
        }
    }

    show(journalHeaderId?: number): void {
        if (!journalHeaderId) {
            this.journalHeader = new JournalHeaderDto();
            this.journalHeader.id = journalHeaderId;
            this.journalHeader.journalDate = this._dateTimeService.getStartOfDay();
            this.active = true;
        } else {
            this._journalHeadersServiceProxy.getJournalForEdit(journalHeaderId).subscribe((result) => {
                this.journalHeader = result.journalHeader;
                this.journalDetails = result.journalDetailDto;
                this.active = true;

                if (this._activatedRoute.snapshot.queryParams['dirinv'] == 0) {
                    this.journalHeader.id = null;
                }
            });
        }

        this._commonLookupServiceProxy.getChartOfAccountForJournals().subscribe((result) => {
            this.allChartOfAccounts = result;
        });

    }

    

    calculateTotalValues(): void {
        debugger;
        var debit = 0;
        var credit = 0;
        this.journalDetails.forEach((val) => {
            if (this.journalHeader.debit == undefined) {
                this.journalHeader.debit = 0;
            }
            if (this.journalHeader.credit == undefined) {
                this.journalHeader.credit = 0;
            }
            debit = debit + Number(val.debit);
            credit = credit + Number(val.credit);
        });

        this.journalHeader.debit = debit;
        this.journalHeader.credit = credit;
    }

    save(): void {

        if (this.journalHeader.debit != this.journalHeader.credit) {
            abp.message.error(this.l('DebitAndCreditNotEqual'));
            return;
        }
        this.saving = true;
        var journalInput = new GetJournalVoucherForInput();
        journalInput.journalHeader = this.journalHeader;
        journalInput.journalDetails = this.journalDetails;
        journalInput.journalHeader.type = JournalType.JournalVoucher;
        this._journalHeadersServiceProxy
            .createorEdit(journalInput)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this._router.navigate(['/app/account/journalVouchers']);
            });
    }

    goBack(): void {
        this._router.navigate(['/app/account/journalVouchers']);
    }
}
